import React from 'react';
import { IMAGES } from './constants/artForms';
import Header from './components/sections/Header';
import Hero from './components/sections/Hero';
import ArtFormSection from './components/sections/ArtFormSection';
import OtherArts from './components/sections/OtherArts';
import Gallery from './components/sections/Gallery';
import Footer from './components/sections/Footer';
import './App.css';

function App() {
  return (
    <div className="antialiased bg-black text-white">
      <Header />
      <main className="pt-24">
        <Hero />
        
        {/* Bharatanatyam Section */}
        <ArtFormSection 
          id="bharatanatyam"
          title="Bharatanatyam"
          image={IMAGES.BHARATANATYAM}
          description={
            <>
              <p className="text-lg text-gray-300">
                Experience the grace and beauty of Bharatanatyam through our vibrant community of 
                dancers across America. Our artists bring this ancient South Indian classical dance 
                form to life, combining traditional techniques with contemporary expressions.
              </p>
              <p className="text-lg text-gray-300 mt-4">
                Join our growing community of performers and enthusiasts who are dedicated to 
                preserving and promoting this art form in America. From regular 
                performances at cultural events to specialized workshops and classes, we offer 
                numerous opportunities to experience and learn Bharatanatyam.
              </p>
              <p className="text-lg text-gray-300 mt-4">
                Discover talented instructors who provide personalized guidance in mastering the 
                intricate footwork, expressive gestures (mudras), and storytelling aspects of 
                Bharatanatyam. Whether you're a beginner or an advanced practitioner, our American 
                community welcomes you to explore this rich artistic tradition.
              </p>
            </>
          }
        />

        {/* Carnatic Music Section */}
        <ArtFormSection 
          id="carnatic-music"
          title="Carnatic Music"
          image={IMAGES.CARNATIC_MUSIC}
          description={
            <>
              <p className="text-lg text-gray-300">
                Immerse yourself in the melodious world of Carnatic music right here in America. 
                Our local musicians and vocalists are keeping this classical South Indian music tradition 
                alive through regular concerts, workshops, and collaborative performances.
              </p>
              <p className="text-lg text-gray-300 mt-4">
                Connect with accomplished American-based artists who specialize in various aspects 
                of Carnatic music - from vocal performances to instrumental mastery on violin, 
                mridangam, and other traditional instruments. Our community regularly organizes music 
                festivals and intimate gatherings to celebrate this rich musical heritage.
              </p>
              <p className="text-lg text-gray-300 mt-4">
                Whether you're an aspiring musician or an appreciative listener, join us in 
                experiencing the depth and beauty of Carnatic music. Discover how this ancient art 
                form continues to thrive and evolve in contemporary America.
              </p>
            </>
          }
          reverse={true}
        />

        {/* Other Arts Section */}
        <OtherArts />

        {/* Gallery Section */}
        <Gallery />

      </main>
      <Footer />
    </div>
  );
}

export default App;
